import BarChartIcon from '@mui/icons-material/Equalizer';
import React from 'react';

const HorizontalBarChartIcon = (
    props: React.ComponentProps<typeof BarChartIcon>,
) => <BarChartIcon {...props} style={{ transform: 'rotate(90deg)' }} />;

export default HorizontalBarChartIcon;
